import { useEffect, useState } from 'react';
import { useLocation  , useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Stack, Typography } from '@mui/material';
import Page from '../components/Page';
import Logo from '../components/Logo';
import Loader from '../components/Loader';
import { LOCALES } from '../utils/constants';
import { setUser } from '../redux/auth/authSlice';

const getExpiryFromToken = (token) => {
  const payload = token.split('.')[1];
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const { exp } = JSON.parse(atob(base64));
  return new Date(exp * 1000).toISOString();
};

export default function AdminRedirect() {
  const { search } = useLocation();
  const { i18n } = useTranslation();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const userId = params.get('userId');
    const lang = params.get('lang');

    if (lang && Object.values(LOCALES).includes(lang.toLowerCase())) {
      i18n.changeLanguage(lang.toLowerCase());
    }

    if (!token || !userId) {
      setError('This redirect link is missing required information.');
      return;
    }

    (async () => {
      try {
        localStorage.removeItem('admin');

        const res = await axios.get(`/admin/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!(res.data.statusCode === 200 || res.data.statusCode === 201)) {
          throw new Error(res.data.message || 'Unable to fetch user details');
        }

        localStorage.setItem(
          'admin',
          JSON.stringify({
            token,
            expireIn: getExpiryFromToken(token),
            userData: res.data.response,
          })
        );
        dispatch(setUser(res.data.response));
        navigate('/dashboard/app');
      } catch (err) {
        const message = err?.response?.data?.message || err.message || 'Something went wrong. Please try again.';
        toast.error(message);
        setError(message);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <Page title="Redirecting">
      {!error && <Loader />}
      {error && (
        <Stack justifyContent="center" alignItems="center" spacing={2} sx={{ minHeight: '100vh', px: 3, textAlign: 'center' }}>
          <Logo />
          <Typography variant="body1" color="error">
            {error}
          </Typography>
        </Stack>
      )}
    </Page>
  );
}
